



import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';

@Component({
  name: 'GeoMapLine',
  components: {},
})
export default class GeoMapLine extends Vue {
  @Prop() public google: any;

  @Prop() public map: any;

  @Prop() public path: any;

  @Prop({ default: false }) protected autoZoom!: boolean;

  @Prop({ default: false }) protected autoCenter!: boolean;

  protected polyline: any = null;

  protected get pathPrepared() {
    if (!this.path) {
      return [];
    }
    return this.path
      .filter((item: any) => Array.isArray(item) && item.length === 2)
      .map(([lng, lat]: any) => ({ lng, lat }));
  }

  @Watch('path', { immediate: true, deep: true })
  protected onChangePath() {
    if (this.polyline) {
      this.polyline.setMap(null);
    }
    // eslint-disable-next-line
    this.polyline = new this.google.maps.Polyline({
      path: this.pathPrepared,
      map: this.map,
      strokeColor: '#366DED',
      strokeOpacity: 1.0,
      strokeWeight: 2,
    });

    if (this.autoZoom) {
      this.updateAutoZoom();
    }
    if (this.autoCenter) {
      this.updateAutoCenter();
    }
  }

  protected getBounds() {
    const bounds: any = new this.google.maps.LatLngBounds();
    this.pathPrepared.forEach((path: any) => {
      const loc = new this.google.maps.LatLng(path.lat, path.lng);
      bounds.extend(loc);
    });
    return bounds;
  }

  protected updateAutoZoom() {
    this.map.fitBounds(this.getBounds());
  }

  protected updateAutoCenter() {
    this.map.panToBounds(this.getBounds());
  }
}
